import React, { useEffect, useState } from 'react'
import { getArticles } from '../../Requests/ArticleRequests'
import CreateArticleModal from './CreateArticleModal'
import ArticleCard from './ArticleCard'
import { PlusIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import ArticleWrittingImage from '../../Assets/Articles/ArticleWritting.webp'
import ParticleLoader from "../ParticleLoader";

function ArticlesTab({ project }) {
    const [articles, setArticles] = useState(null)
    const [createArticleModal, setCreateArticleModal] = useState(null)
    const [loading, setLoading] = useState(true)
    const { t } = useTranslation()

    useEffect(() => {
        if (project?.id) {
            getArticles(project.id).then((res) => {
                setArticles(res.data.articles)
            }).catch((error) => {
                console.error('Error fetching articles:', error)
                setArticles([])
            }).finally(() => {
                setLoading(false)
            })
        }
    }, [project])

    const handleCreateArticle = () => {
        setCreateArticleModal(
            <CreateArticleModal
                projectId={project.id}
                onClose={() => setCreateArticleModal(null)}
                onSuccess={(newArticle) => {
                    setArticles(prev => prev ? [...prev, newArticle] : [newArticle])
                    setCreateArticleModal(null)
                }}
            />
        )
    }

    if (loading) {
        return (
            <div className="flex items-center justify-center py-12">
                <ParticleLoader size={32} />
            </div>
        )
    }

    return (
        <div className="mt-4">
            {/* Header with Create Button */}
            <div className="flex justify-between items-center mb-6">
                <div>
                    <div className="flex gap-2 items-center">
                        <h3 className="text-lg font-semibold text-gray-900">{t('articles.title')}</h3>
                        <span className='bg-black rounded-full text-white px-4 py-0.5 text-sm animate-pulse'>Beta</span>
                    </div>
                    <p className="text-sm text-gray-600">{t('articles.description')}</p>
                </div>
                <button
                    onClick={handleCreateArticle}
                    className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800"
                >
                    <PlusIcon className="h-5 w-5" />
                    {t('articles.newArticle')}
                </button>
            </div>

            {/* Articles Grid */}
            {articles && articles.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {articles.map((article) => (
                        <ArticleCard
                            key={article.id}
                            article={article}
                            projectUuid={project.uuid}
                        />
                    ))}
                </div>
            ) : (
                <div className="text-center py-12 bg-white rounded-lg">
                    <div className="mx-auto flex items-center justify-center">
                        <img
                            src={ArticleWrittingImage}
                            alt="Article Writing"
                            className="h-64 w-64 object-contain"
                        />
                    </div>
                    <h3 className="mt-2 text-sm font-medium text-gray-900">{t('articles.noArticlesYet')}</h3>
                    <p className="mt-1 text-sm text-gray-500">
                        {t('articles.getStartedText')}
                    </p>
                    <div className="mt-6">
                        <button
                            onClick={handleCreateArticle}
                            className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-gray-800"
                        >
                            <PlusIcon className="-ml-1 mr-2 h-5 w-5" />
                            {t('articles.newArticle')}
                        </button>
                    </div>
                </div>
            )}

            {createArticleModal}
        </div>
    )
}

export default ArticlesTab
